var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('AppNav'),_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1),_c('ToastNotification'),_c('UpdateAnnouncement'),_c('MessageCenter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }